
import { ReactNode } from "react";
import ProtectedRoute from "@/components/ProtectedRoute";

export const getDashboardByRole = (role: string, userTier?: string) => {
  switch (role) {
    case "admin":
      return "/admin";
    case "host":
      return "/host";
    case "guest":
      // If user is a promoter, redirect to promoter dashboard
      if (userTier === 'promoter') {
        return "/community/referrals";
      }
      return "/guest";
    case "promoter":
      // Handle direct promoter role
      return "/community/referrals";
    default:
      // Check if user has promoter tier regardless of role
      if (userTier === 'promoter') {
        return "/community/referrals";
      }
      return "/";
  }
};

// Helper function to create protected routes
export const createProtectedRoute = (
  element: ReactNode,
  requiredRole?: "admin" | "host" | "guest",
  requirePromoter?: boolean
) => {
  return {
    element: <ProtectedRoute requiredRole={requiredRole} requirePromoter={requirePromoter}>{element}</ProtectedRoute>,
  };
};

// Helper function to create routes configuration
export const createRoutesConfig = (
  basePath: string,
  layoutComponent: ReactNode,
  requiredRole?: "admin" | "host" | "guest",
  requirePromoter?: boolean
) => {
  return {
    path: basePath,
    ...createProtectedRoute(layoutComponent, requiredRole, requirePromoter),
  };
};
